export const SUBSCRIBE_CHANNEL = 'localizationSubscribe';
export const TEXT_DIRECTION_LTR = 'ltr';
